import { render, staticRenderFns } from "./CollegeSettings.vue?vue&type=template&id=cc7f3512"
import script from "./CollegeSettings.vue?vue&type=script&lang=js"
export * from "./CollegeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports